import { $getNodeByKey, type LexicalEditor } from 'lexical';

import { $createActionNode, type ActionNode } from './nodes/ActionNode';

export const switchTagReference = (
  editor: LexicalEditor,
  nodeKey: string,
  prefix: string,
  id: string,
) => {
  editor.update(() => {
    const node = $getNodeByKey<ActionNode>(nodeKey);
    if (!node) {
      throw new Error('Stale node key received, unable to update.');
    }

    const newNode = $createActionNode({
      prefix,
      id,
    });

    node.replace(newNode);
  });
};
